@if (mode() === 'trigger') {
<div class="relative">
    <button type="button" #assignmentFiltersButton command="show-modal" commandfor="assignmentFiltersDrawer"
        (click)="openPanel()"
        class="inline-flex items-center gap-1.5 rounded-md border border-zinc-200 dark:border-white/10 bg-white dark:bg-transparent px-3 py-2 text-xs font-medium text-secondary hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
        [class]="activeChipCount() > 0
            ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
            : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4"
            aria-hidden="true">
            <path
                d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
        </svg>
        <p class="m-0">Filters</p>
        @if (activeChipCount() > 0) {
        <p class="m-0 rounded-full bg-[#7421FB] text-white px-1.5 py-0.5 text-xxs leading-none">{{ activeChipCount() }}
        </p>
        }
    </button>

    <el-dialog>
        <dialog #assignmentFiltersDialog id="assignmentFiltersDrawer" aria-labelledby="assignmentFiltersDrawer-title"
            class="m-0 bg-transparent p-0 max-w-none overflow-visible backdrop:bg-transparent">
            <div (click)="closePanel()" class="fixed inset-0 z-10"></div>
            <el-dialog-panel
                class="fixed z-30 mt-2 w-96 max-h-[min(80vh,40rem)] overflow-y-auto max-w-[calc(100vw-2rem)] rounded-lg border border-zinc-200 dark:border-white/10 bg-white dark:bg-zinc-900 shadow-lg p-4"
                [style.top.px]="panelTop()"
                [style.left.px]="panelLeft()"
                (click)="$event.stopPropagation()">
                <div class="flex flex-col gap-4">
                    <div class="flex items-start justify-between gap-2">
                        <div>
                            <p id="assignmentFiltersDrawer-title" class="m-0 text-sm font-semibold text-primary">Filter the list</p>
                            <!-- <p class="m-0 mt-0.5 text-xs text-secondary">Narrow the list</p> -->
                        </div>
                        <button type="button" (click)="closePanel()" class="btn-fab-secondary text-secondary"
                            aria-label="Close filters">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-4" aria-hidden="true">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                        </button>
                    </div>

                    <!-- Country -->
                    <fieldset class="m-0 p-0 border-0">
                        <legend class="text-xs font-medium text-secondary mb-1.5">Country</legend>
                        <div class="flex flex-wrap gap-1.5">
                            <button type="button" (click)="selectCountry(null)"
                                class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().country === null
                                    ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                    : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                Any
                            </button>
                            @for (country of countryOptions; track country.id) {
                            <button type="button" (click)="selectCountry(country.id)"
                                class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().country === country.id
                                    ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                    : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                {{ country.name }}
                            </button>
                            }
                        </div>
                    </fieldset>

                    <!-- Gender -->
                    <fieldset class="m-0 p-0 border-0">
                        <legend class="text-xs font-medium text-secondary mb-1.5">Gender</legend>
                        <div class="flex flex-wrap gap-1.5">
                            <button type="button" (click)="selectGender(null)"
                                class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().gender === null
                                    ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                    : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                Any
                            </button>
                            @for (gender of genderOptions; track gender.id) {
                            <button type="button" (click)="selectGender(+gender.id)"
                                class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().gender === gender.id
                                    ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                    : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                {{ gender.name }}
                            </button>
                            }
                        </div>
                    </fieldset>

                    <!-- Min rating -->
                    <fieldset class="m-0 p-0 border-0">
                        <legend class="text-xs font-medium text-secondary mb-1.5">Minimum rating</legend>
                        <div class="flex flex-wrap gap-1.5">
                            <button type="button" (click)="selectRating(null)"
                                class="rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().rating === null
                                    ? 'bg-primary border-primary text-white'
                                    : 'border-zinc-200 dark:border-white/10 bg-white dark:bg-transparent text-secondary hover:text-primary'">
                                Any
                            </button>
                            @for (option of ratingOptions; track option.value) {
                            <button type="button" (click)="selectRating(option.value)"
                                class="rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
                                [class]="draft().rating === option.value
                                    ? 'bg-primary border-primary text-white'
                                    : 'border-zinc-200 dark:border-white/10 bg-white dark:bg-transparent text-secondary hover:text-primary'">
                                {{ option.label }}
                            </button>
                            }
                        </div>
                    </fieldset>

                    <!-- Age -->
                    <div class="grid grid-cols-2 gap-2">
                        <div class="flex flex-col gap-1.5">
                            <label for="assignment-age-min" class="text-xs font-medium text-secondary">Min age</label>
                            <input id="assignment-age-min" type="number" min="0" max="120" step="1"
                                class="input-primary w-full text-sm" placeholder="18"
                                [value]="draft().ageFrom ?? ''"
                                (input)="onAgeFromInput($any($event.target).value)" />
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="assignment-age-max" class="text-xs font-medium text-secondary">Max age</label>
                            <input id="assignment-age-max" type="number" min="0" max="120" step="1"
                                class="input-primary w-full text-sm" placeholder="65"
                                [value]="draft().ageTo ?? ''"
                                (input)="onAgeToInput($any($event.target).value)" />
                        </div>
                    </div>

                    <!-- Toggles -->
                    <div class="flex flex-col gap-3">
                        <label class="flex items-center justify-between gap-3 cursor-pointer">
                            <p class="m-0 text-xs font-medium text-primary">Verified only</p>
                            <button type="button" role="switch" [attr.aria-checked]="draft().isVerified"
                                (click)="setVerifiedOnly(!draft().isVerified)"
                                class="relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                [class]="draft().isVerified ? 'bg-primary' : 'bg-zinc-200 dark:bg-zinc-700'">
                                <span class="inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform"
                                    [class]="draft().isVerified ? 'translate-x-5' : 'translate-x-0.5'"></span>
                            </button>
                        </label>
                        <label class="flex items-center justify-between gap-3 cursor-pointer">
                            <p class="m-0 text-xs font-medium text-primary">Has reviews</p>
                            <button type="button" role="switch" [attr.aria-checked]="draft().hasReviews"
                                (click)="setHasReviews(!draft().hasReviews)"
                                class="relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                [class]="draft().hasReviews ? 'bg-primary' : 'bg-zinc-200 dark:bg-zinc-700'">
                                <span class="inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform"
                                    [class]="draft().hasReviews ? 'translate-x-5' : 'translate-x-0.5'"></span>
                            </button>
                        </label>
                    </div>

                    <!-- Screening applies to UGC and social-post briefs (alongside follower mins when present). -->
                    @if (screeningQuestions().length > 0) {
                    <div class="flex flex-col gap-3 border-t border-zinc-200 dark:border-white/10 pt-3">
                        <p class="m-0 text-xs font-semibold text-primary">Screening questions</p>
                        @for (question of screeningQuestions(); track question.id) {
                        <fieldset class="m-0 p-0 border-0">
                            <legend class="text-xs font-medium text-secondary mb-1.5 leading-snug">
                                {{ question.question }}
                            </legend>
                            <div class="flex flex-wrap gap-1.5">
                                <button type="button" (click)="selectScreening(question.id, null)"
                                    class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                    [class]="!draft().screening[question.id]
                                        ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                        : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                    Any
                                </button>
                                @for (option of question.options; track option.value) {
                                <button type="button" (click)="selectScreening(question.id, option.value)"
                                    class="rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors"
                                    [class]="draft().screening[question.id] === option.value
                                        ? 'bg-[#F0E6FE] border-[#D1B5FD] text-[#7421FB]'
                                        : 'border-zinc-200 dark:border-white/10 text-secondary hover:text-primary'">
                                    {{ option.label }}
                                </button>
                                }
                            </div>
                        </fieldset>
                        }
                    </div>
                    }

                    @if (isSocialBrief()) {
                    <div class="grid grid-cols-2 gap-2"
                        [class]="screeningQuestions().length > 0 ? 'border-t border-zinc-200 dark:border-white/10 pt-3' : ''">
                        <div class="flex flex-col gap-1.5">
                            <label for="assignment-min-tiktok"
                                class="inline-flex items-center gap-1.5 text-xs font-medium text-secondary">
                                <img src="assets/social-icon/tik-tok-transparent.svg" alt="" class="size-4" aria-hidden="true" />
                                Min followers
                            </label>
                            <input id="assignment-min-tiktok" type="text" inputmode="numeric" autocomplete="off"
                                class="input-primary w-full text-sm" placeholder="10,000"
                                [value]="formatFollowerCount(draft().tikTokFollowersFrom)"
                                (input)="onTikTokMinInput($any($event.target).value)"
                                aria-label="Minimum TikTok followers" />
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="assignment-min-instagram"
                                class="inline-flex items-center gap-1.5 text-xs font-medium text-secondary">
                                <img src="assets/social-icon/instagram-logo.png" alt="" class="size-4" aria-hidden="true" />
                                Min followers
                            </label>
                            <input id="assignment-min-instagram" type="text" inputmode="numeric" autocomplete="off"
                                class="input-primary w-full text-sm" placeholder="10,000"
                                [value]="formatFollowerCount(draft().instagramFollowersFrom)"
                                (input)="onInstagramMinInput($any($event.target).value)"
                                aria-label="Minimum Instagram followers" />
                        </div>
                    </div>
                    }

                    <div class="flex items-center justify-end gap-2 pt-1 border-t border-zinc-200 dark:border-white/10">
                        <button type="button" (click)="clearFilters()"
                            class="rounded-md px-3 py-2 text-xs font-medium text-secondary hover:text-primary">
                            Clear
                        </button>
                        <button type="button" (click)="applyFilters()" class="btn-shout btn-shout-xs btn-shout-primary">
                            Apply
                        </button>
                    </div>
                </div>
            </el-dialog-panel>
        </dialog>
    </el-dialog>
</div>
}

@if (mode() === 'chips' && activeChips().length > 0) {
<div class="flex flex-row items-center justify-start gap-2 overflow-x-auto py-1 w-full" aria-label="Active filters">
    @if (manageBriefTabsService.applicantsTotalCount() !== null) {
    <p class="m-0 text-xs font-semibold text-primary whitespace-nowrap shrink-0">
        {{ manageBriefTabsService.applicantsTotalCount() }}
        {{ manageBriefTabsService.applicantsTotalCount() === 1 ? 'applicant' : 'applicants' }}
    </p>
    }
    @for (chip of activeChips(); track chip.key) {
    <span
        class="gap-x-1 inline-flex items-center rounded-full bg-[#F0E6FE] dark:bg-primary/25 px-3 py-1 text-xs font-medium text-[#7421FB] dark:text-violet-200 whitespace-nowrap">
        <p class="m-0">{{ chip.label }}</p>
        <button (click)="removeChip(chip.key)" type="button"
            class="group relative -mr-0.5 size-3.5 rounded-xs hover:bg-[#7421FB]/15"
            [attr.aria-label]="'Remove ' + chip.label">
            <svg viewBox="0 0 14 14"
                class="size-3.5 stroke-[#7421FB]/70 group-hover:stroke-[#7421FB] dark:stroke-violet-200"
                aria-hidden="true">
                <path d="M4 4l6 6m0-6l-6 6" />
            </svg>
            <span class="absolute -inset-1"></span>
        </button>
    </span>
    }
    <button type="button" (click)="clearFilters()"
        class="text-xs font-medium text-[#7421FB] hover:text-[#5b1ac7] whitespace-nowrap px-1">
        Clear all
    </button>
</div>
}
